module.exports = __webpack_public_path__ + "img/T360_98Score_Report_BMW.474d7769.png";